import { SelectableFilterOption }
  from '@/components/common/TableGrid/CustomComponents/AgGridSelectableFilter/AgGridSelectableFilter';
import { BillingCycleOutput } from '@/graphql/contracts/_generated_/contracts';

export class BillingCycleFilterComparators {
  static stockCodeComparator(billingCycle: BillingCycleOutput, selectedOptions: SelectableFilterOption[]) {
    const stockCode = billingCycle.stockCode;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === stockCode);
    return Boolean(appropriateOption);
  }

  static processingStatusComparator(billingCycle: BillingCycleOutput, selectedOptions: SelectableFilterOption[]) {
    const status = billingCycle.processingStatus;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === status);
    return Boolean(appropriateOption);
  }

  static statusReasonComparator(billingCycle: BillingCycleOutput, selectedOptions: SelectableFilterOption[]) {
    const statusReason = billingCycle.statusReason;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === statusReason);
    return Boolean(appropriateOption);
  }

  static consolidationCriteriaCodeComparator(
    billingCycle: BillingCycleOutput, 
    selectedOptions: SelectableFilterOption[]
  ) {
    const consolidationCriteriaCode = billingCycle.consolidationCriteriaCode;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === consolidationCriteriaCode);
    return Boolean(appropriateOption);
  }

  static contractLineIDComparator(billingCycle: BillingCycleOutput, selectedOptions: SelectableFilterOption[]) {
    const contractLineID = billingCycle.contractLineID;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === contractLineID);
    return Boolean(appropriateOption);
  }
}
